import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class DewpointSensorNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.DewpointSensor,
    });
  }
}
